<template>
    <div class="booking-summary">
        <div class="booking-summary__block">
            <div class="booking-summary__text">
                <div>
                    <strong class="booking-summary-text--smaller">
                        {{ header }}
                    </strong>

                    <small v-if="!loading && shouldOfferAlternatives">
                        You can still make an enquiry for your chosen time if you wish, but do please note that {{ venue.name }} appears to be full at the time you selected.
                    </small>

                </div>

                <div>{{ venue.name }}</div>
                <div>{{ pax }} people</div>
                <div>{{ DateService.friendlyDate(date) }}</div>
                <div>{{ type.name }}</div>
                <div>{{ times.getFriendlyStartTime() }} - {{ times.getFriendlyEndTime() }}</div>

            </div>

            <div>
              <button class="button" v-on:click="changeDetails" type="button" title="Change Details">&laquo; Change Details</button>
              <button class="button" v-on:click="findAlternatives" type="button" v-if="!loading && shouldOfferAlternatives">See Alternatives</button>
            </div>

            <template v-if="!loading">
                <div v-if="preorderPaymentMsg" class="booking-summary-offers booking-summary-callout booking-summary-callout--warning">
                    <span v-html="preorderPaymentMsg"></span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
  import { TimeAction } from '../services/TimesProvider'
  import DateService from '../services/DateService'

  export default {
    name: 'bookingSummary',
    props: [
      'status',
      'venue',
      'type',
      'date',
      'pax',
      'error',
      'times',
      'endTime',
      'loading',
      'preorderPaymentMsg'
    ],
    data () {
      return {
        DateService
      }
    },
    methods: {
      changeDetails () {
        this.$emit('changeDetails')
      },
      findAlternatives () {
        this.$emit('findAlternatives')
      }
    },
    computed: {
      header: function () {
        if (this.loading) {
          return 'Checking availability...'
        }

        if (this.error) {
          return 'An error occurred'
        }

        switch (this.status) {
          case TimeAction.reject:
            return 'No availability'
          case TimeAction.accept:
          case TimeAction.confirm:
          case TimeAction.success:
            return 'Complete your booking below'
          default:
            return 'Complete your enquiry below'
        }
      },
      shouldOfferAlternatives: function () {
        return this.status === TimeAction.mayAccept
      }
    }
  }
</script>



// WEBPACK FOOTER //
// bookingSummary.vue?895b5314